import {
  BooleanInput,
  TextInput,
  useRecordContext,
  ValidateForm,
} from "react-admin";

import {
  AUTH0_CONNECTION_NAME_TOOLTIP_TEXT,
  SSO_INFO_NOTES_MAX_LENGTH,
} from "../../constants";
import { DataKind, SsoInfoResponse } from "../../types";
import validators from "../../utils/Validators";
import { CustomEdit, CustomNumberInput, LabelWithInfoTooltip } from "../custom";

function SsoInfoEditInputs() {
  const record = useRecordContext<SsoInfoResponse>();
  const isEnabled = Boolean(record?.is_enabled);

  return (
    <>
      <CustomNumberInput
        label="Account ID"
        source="account_id"
        required
        disabled={isEnabled}
      />
      <TextInput label="Domain" source="domain" required disabled={isEnabled} />
      <TextInput
        label={
          <LabelWithInfoTooltip
            labelText="Auth0 Connection Name"
            tooltipText={AUTH0_CONNECTION_NAME_TOOLTIP_TEXT}
          />
        }
        source="auth0_connection_name"
        required
        disabled={isEnabled}
      />
      <TextInput
        label="Notes"
        source="notes"
        multiline
        minRows={3}
        fullWidth
        inputProps={{ maxLength: SSO_INFO_NOTES_MAX_LENGTH }}
        disabled={isEnabled}
      />
      <BooleanInput
        label="Is Enabled"
        source="is_enabled"
        disabled
        helperText={
          isEnabled
            ? "Disable this SSO info on the detail page before editing it."
            : "Use Enable on the detail page to turn on SSO."
        }
      />
    </>
  );
}

function SsoInfoEdit() {
  const validateForm: ValidateForm = (values: any) =>
    validators.validateAuth0ConnectionName(values.auth0_connection_name);

  return (
    <CustomEdit checkPermissionFor={DataKind.SsoInfo} validate={validateForm}>
      <SsoInfoEditInputs />
    </CustomEdit>
  );
}

export default SsoInfoEdit;
